module.exports = __webpack_public_path__ + "static/media/AppleStore.426c1c15.png";